<script setup lang="ts">
import { computed, type PropType } from 'vue'
import { useShipTypeStore } from '@/stores/shipType'

import GroupRowField from '@/components/form/GroupRowField.vue'

import { storeToRefs } from 'pinia'

const props = defineProps({
	modelValue: {
		type: Object as PropType<Record<string, any>>,
		required: true
	},
	equalColumns: {
		type: Boolean,
		default: false
	},
	disabled: {
		type: Boolean,
		default: false
	},
	inline: {
		type: Boolean,
		default: true
	}
})

const shipTypeStore = useShipTypeStore()
const { items: shipTypes } = storeToRefs(shipTypeStore)

const emit = defineEmits<{
	(e: 'update:modelValue', value: Record<string, any>): void
}>()

const vModel = computed({
	get: () => props.modelValue.type,
	set: (value: number) => {
		if (props.modelValue) {
			emit('update:modelValue', { ...props.modelValue, type: value })
		}
	}
})
</script>

<template>
	<GroupRowField :equal-columns="equalColumns">
		<template v-slot:label> Ship type </template>
		<template v-slot:field>
			<v-select
				:items="shipTypes"
				color="primary"
				v-model="vModel"
				item-title="name"
				item-value="id"
				label="Ship type"
				persistent-hint
				:rules="[(v) => !!v || 'Type is required']"
			></v-select>
		</template>
	</GroupRowField>
</template>

<style scoped>
.v-text-field :deep(.v-input__details) {
	padding-left: 0;
	padding-bottom: 2px;
	padding-top: 2px;
	min-height: 12px;
	word-break: break-word;
}
</style>
